<script>
    export default {
        props: {
            value: {
                default: null
            }
        },
        data() {
            return {
                option: this.value
            }
        },
        methods: {
            set(value) {
                this.option = value;
                this.update();
            },
            update() {
                this.$emit('input', this.option);
            },
            isSelected(value) {
                return this.option === value;
            }
        },
        render() {
            return this.$scopedSlots.default({
                set: this.set,
                isSelected: this.isSelected,
            });
        }
    }
</script>